<template>
  <div class="category-container">
    <pageTitle>小程序管理员信息管理</pageTitle>

    <div class="main">
      <el-button type="primary" plain @click="addAppletAdministratorDialog=true">添加小程序管理员信息</el-button>
      <el-dialog title="新增小程序管理员信息" :visible.sync="addAppletAdministratorDialog">
        <el-form :model="addAppletAdministratorData" ref="addAppletAdministratorData"
                 :rules="addAppletAdministratorRules"
                 label-width="200px">
          <el-form-item label="小程序管理员用户名" prop="username">
            <el-input v-model="addAppletAdministratorData.username"></el-input>
          </el-form-item>
          <el-form-item label="小程序管理员密码" prop="password">
            <el-input v-model="addAppletAdministratorData.password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addAppletAdministratorDialog = false">取 消</el-button>
          <el-button type="primary" @click="addAppletAdministrator('addAppletAdministratorData')">确 定</el-button>
        </div>
      </el-dialog>


      <div class="categoryList">
        <el-table :data="appletAdministratorListData" stripe style="width:100%;margin-bottom: 35px;">
          <el-table-column width="400px" prop="username" label="小程序管理员用户名"></el-table-column>
          <el-table-column width="420px" prop="password" label="小程序管理员密码"></el-table-column>
          <!--          <el-table-column width="350px" prop="system_status" label="小程序管理员状态"></el-table-column>-->
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column width="180px" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" plain
                         @click.native.prevent="editorAppletAdministratorItemDataDialog(scope.$index, scope.row)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>


      <el-dialog title="编辑小程序管理员信息" :visible.sync="editorAppletAdministratorDialog">
        <el-form :model="editorAppletAdministratorData" ref="editorAppletAdministratorData"
                 :rules="addAppletAdministratorRules"
                 label-width="200px">
          <el-form-item label="小程序管理员用户名" prop="username">
            <el-input v-model="editorAppletAdministratorData.username"></el-input>
          </el-form-item>
          <el-form-item label="小程序管理员密码" prop="password">
            <el-input v-model="editorAppletAdministratorData.password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editorAppletAdministratorDialog = false">取 消</el-button>
          <el-button type="primary" @click="editorAppletAdministrator('editorAppletAdministratorData')">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import pageTitle from "../components/pageTitle";

export default {
  name: "appletAdministrator",
  components: {
    pageTitle
  },
  data() {
    return {
      //添加小程序管理员数据
      addAppletAdministratorData: {},
      //添加小程序管理员数据验证规则
      addAppletAdministratorRules: {
        username: [
          {required: true, message: '请输入小程序管理员用户名', trigger: 'blur'},
        ],
        password: [
          {required: true, message: "请输入小程序管理员密码", trigger: "blur"}
        ],
      },

      //小程序管理员列表数据
      appletAdministratorListData: null,

      //添加小程序管理员数据模态框
      addAppletAdministratorDialog: false,

      //编辑小程序管理员数据
      editorAppletAdministratorData: {},
      //编辑小程序管理员数据模态框
      editorAppletAdministratorDialog: false
    }
  },
  methods: {
    //获取公司数据
    getAppletAdministratorListData() {
      this.axios.post('appletAdministrator/getAppletAdministratorList').then(success => {
        if (success.data.data) {
          for (const item in success.data.data) {
            success.data.data[item].create_time = success.data.data[item].create_time.substring(0, success.data.data[item].create_time.length - 4)
          }
          this.appletAdministratorListData = success.data.data
        }
      })
    },

    //添加小程序管理员
    addAppletAdministrator(appletAdministratorData) {
      this.$refs[appletAdministratorData].validate((valiResult) => {
        if (valiResult) {
          this.axios.post('appletAdministrator/addAppletAdministrator', this.addAppletAdministratorData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '添加小程序管理员信息成功'
              })
              this.getAppletAdministratorListData()
              this.addAppletAdministratorDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //编辑小程序管理员
    editorAppletAdministrator(appletAdministratorData) {
      this.$refs[appletAdministratorData].validate((valiResult) => {
        if (valiResult) {

          this.axios.post('appletAdministrator/updateAppletAdministrator', this.editorAppletAdministratorData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '编辑小程序管理员信息成功'
              })
              this.getAppletAdministratorListData()
              this.addAppletAdministratorDialog = false
              this.editorAppletAdministratorDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //打开编辑模态框
    editorAppletAdministratorItemDataDialog(index, row) {
      this.editorAppletAdministratorDialog = true
      this.editorAppletAdministratorData = {
        id: row.id,
        username: row.username,
        password: row.password,
        system_status: row.system_status,
        company_phone: row.company_phone
      }
    }
  },
  created() {
    this.getAppletAdministratorListData()
  }
}
</script>

<style scoped lang="scss">

.category-container {

  .main {
    margin-left: 10px;

    .categoryList {
      margin-top: 30px;

      ul {
        border-radius: 5px;
        overflow: hidden;

        li {
          list-style: none;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #707070;
          background-color: #DCDFE6;

          label {
            float: left;
            margin-left: 20px;
          }

          .el-button {
            float: right;
            margin-top: 5px;
            margin-right: 10px;
          }
        }

        li:hover {
          background-color: #c0c4cc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/appletAdministrator.vue